import type { HelpFile } from '../../types/help'
import { PreviewResultDialogTestIds } from '../../../testids/PreviewResultDialogTestIds'

export const previewResultDialogHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [PreviewResultDialogTestIds.previewResultDialog]:
      'Raw response from the source system captured during a preview run — useful for debugging mappings before triggering a full sync.',
    [PreviewResultDialogTestIds.previewBody]: null,
    [PreviewResultDialogTestIds.previewEmpty]: null,
    [PreviewResultDialogTestIds.previewLoading]: null,
    [PreviewResultDialogTestIds.btnClosePreview]: null,
    [PreviewResultDialogTestIds.btnDownloadPreview]:
      'Download the captured response body to a file for offline inspection.',
  },
}
